import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Box, MenuItem } from '@mui/material';
import { operationDiagnosisOptions } from '../../constants/options';

const DiagnosisSection = ({ formData, handleChange, setFormData, errors }) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 1: Diagnosis & Procedure Type
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
            <Autocomplete
                freeSolo
                options={operationDiagnosisOptions}
                value={formData.pre_op_diagnosis || ''}
                onChange={(_, newVal) => setFormData(prev => ({ ...prev, pre_op_diagnosis: newVal }))}
                renderInput={(params) => (
                <TextField
                    {...params}
                    label="Pre-Op Diagnosis"
                    required
                    fullWidth
                    InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'red' } } }}
                    error={!!errors.pre_op_diagnosis}
                    helperText={errors.pre_op_diagnosis}
                />
                )}
            />
        </Grid>
        
        <Grid item xs={12} sm={6}>
            <TextField
                select
                label="Type of Procedure"
                name="type_of_procedure"
                value={formData.type_of_procedure || ''}
                onChange={handleChange}
                required
                fullWidth
                InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'red' } } }}
                error={!!errors.type_of_procedure}
                helperText={errors.type_of_procedure}
            >
                <MenuItem value="Major">Major</MenuItem>
                <MenuItem value="Minor">Minor</MenuItem>
            </TextField>
        </Grid>

        <Grid item xs={12}>
            <Autocomplete
                freeSolo
                options={operationDiagnosisOptions}
                value={formData.post_op_diagnosis || ''}
                onChange={(_, newVal) => setFormData(prev => ({ ...prev, post_op_diagnosis: newVal }))}
                renderInput={(params) => (
                <TextField
                    {...params}
                    label="Post-Op Diagnosis"
                    required
                    fullWidth
                    InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'red' } } }}
                    error={!!errors.post_op_diagnosis}
                    helperText={errors.post_op_diagnosis}
                />
                )}
            />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DiagnosisSection;
